import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "machine" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = { class: "name ellipsis" }
const _hoisted_4 = {
  key: 0,
  class: "status"
}
const _hoisted_5 = { class: "content form" }
const _hoisted_6 = { class: "field" }
const _hoisted_7 = { class: "value ellipsis" }
const _hoisted_8 = { class: "field" }
const _hoisted_9 = { class: "value ellipsis" }
const _hoisted_10 = { class: "footer" }

import { FacilityDto } from '@/api/attendance'
import { EditPen } from '@element-plus/icons-vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'machine-card',
  props: {
    data: { default: () => ({}) }
  },
  emits: ["editMachine", "detailMachine", "removeMachine"],
  setup(__props: any, { emit: __emit }) {


const props = __props
const emits = __emit

return (_ctx: any,_cache: any) => {
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_space = _resolveComponent("el-space")!
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.data.name), 1),
      (_ctx.data.status === 2)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, "已解绑"))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _cache[3] || (_cache[3] = _createElementVNode("div", { class: "label" }, "SN 码：", -1)),
        _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.data.snCode), 1)
      ]),
      _createElementVNode("div", _hoisted_8, [
        _cache[4] || (_cache[4] = _createElementVNode("div", { class: "label" }, "添加时间：", -1)),
        _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.data.createTime), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("div", null, [
        (_ctx.data.status !== 2)
          ? (_openBlock(), _createBlock(_component_el_button, {
              key: 0,
              type: "text",
              size: "mini",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (emits('editMachine', _ctx.data)))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_space, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_icon, null, {
                      default: _withCtx(() => [
                        _createVNode(_unref(EditPen))
                      ]),
                      _: 1
                    }),
                    _cache[5] || (_cache[5] = _createElementVNode("div", null, "编辑", -1))
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", null, [
        (_ctx.data.status === 2)
          ? (_openBlock(), _createBlock(_component_el_button, {
              key: 0,
              type: "danger",
              size: "mini",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (emits('removeMachine', _ctx.data)))
            }, {
              default: _withCtx(() => _cache[6] || (_cache[6] = [
                _createTextVNode("删除")
              ])),
              _: 1
            }))
          : _createCommentVNode("", true),
        _createVNode(_component_el_button, {
          type: "primary",
          size: "mini",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (emits('detailMachine', _ctx.data)))
        }, {
          default: _withCtx(() => _cache[7] || (_cache[7] = [
            _createTextVNode("考勤名单")
          ])),
          _: 1
        })
      ])
    ])
  ]))
}
}

})